/**************************************************************************
Name:         jquery.datepicker.js
Description:  Date picker widget. Requires moment.min.js.
Date Created: 1/23/2013 by Kyle Brickman
Modified:
**************************************************************************/


( function( $ ){
	$.fn.datepicker = function( options )
	{
		var settings = $.extend({
			format         : 'MM-DD-YYYY',
			overrideMobile : false,
			minYear        : -10,
			maxYear        : +5,
			myWUSATADate   : false
		}, options );
		
		return this.filter( 'input[type="text"],input[type="date"]' ).each( function( index ){
			// Instantiate bound functions
			var normalizeDate = function( )
			{
							
				if( local.date.year > local.settings.maxYear ) local.date.year = local.settings.maxYear;
				if( local.date.year < local.settings.minYear ) local.date.year = local.settings.minYear;

				if( local.date.month > 12 ) local.date.month = 12;
				if( local.date.month < 1  ) local.date.month = 1;

				if( local.date.day > moment( ).year( local.date.year ).month( local.date.month-1 ).date( 10 ).daysInMonth( ))
					local.date.day = moment( ).year( local.date.year ).month( local.date.month-1 ).date( 10 ).daysInMonth( );

				local.date.year  = parseInt( local.date.year,  10 );
				local.date.month = parseInt( local.date.month, 10 );
				local.date.day   = parseInt( local.date.day,   10 );

				return;
			};

			var drawHeader = function( )
			{
				local.calendar.mDec.detach( );
				local.calendar.mInc.detach( );
				local.calendar.yDec.detach( );
				local.calendar.yInc.detach( );

				local.calendar.month.html( ['','January','February','March','April','May','June','July','August','September','October','November','December'][local.date.month] );
				local.calendar.year.html( '&nbsp;' + local.date.year );

				local.calendar.mDec.appendTo( local.calendar.month );
				local.calendar.mInc.appendTo( local.calendar.month );
				local.calendar.yDec.appendTo( local.calendar.year  );
				local.calendar.yInc.appendTo( local.calendar.year  );

				local.calendar.mDec.removeClass( 'disabled' );
				local.calendar.mInc.removeClass( 'disabled' );
				local.calendar.yDec.removeClass( 'disabled' );
				local.calendar.yInc.removeClass( 'disabled' );

				if( moment( ).year( local.date.year ).month( local.date.month - 1 ).date( 1 ).add( 'M', -1 ).year( ) < local.settings.minYear ) local.calendar.mDec.addClass( 'disabled' );
				if( moment( ).year( local.date.year ).month( local.date.month - 1 ).date( 1 ).add( 'M', +1 ).year( ) > local.settings.maxYear ) local.calendar.mInc.addClass( 'disabled' );

				if( moment( ).year( local.date.year ).month( 1 ).date( 1 ).add( 'y', -1 ).year( ) < local.settings.minYear ) local.calendar.yDec.addClass( 'disabled' );
				if( moment( ).year( local.date.year ).month( 1 ).date( 1 ).add( 'y', +1 ).year( ) > local.settings.maxYear ) local.calendar.yInc.addClass( 'disabled' );

				return;
			};

			var drawGrid = function( )
			{
				local.calendar.grid.empty( );

				var dates = [];

				for( var i = 1; i <= moment( ).year( local.date.year ).month( local.date.month - 1 ).date( 1 ).daysInMonth( ); i++ )
					dates.push( moment( ).year( local.date.year ).month( local.date.month - 1 ).date( i ));

				var currentYear = moment( ).year( );
				var currentMonth = moment( ).month( );
				var currentDay = moment( ).date( );

				var firstDate = dates[0];
				var lastDate  = dates[dates.length - 1];

				for( i = 0; i < firstDate.day( ); i++ )
					dates.unshift( moment( firstDate ).add( 'd', ( i + 1 ) * -1 ));

				while( 0 != dates.length % 7 )
				{
					dates.push( moment( lastDate ).add( 'd', 1 ));
					lastDate = dates[dates.length - 1];
				}

				var newGrid = $( '<ol />' );

				for( i = 0; i < dates.length; i++ )
				{
					var gridItem = $( '<li />' );
					var gridLink = $( '<a  />' );

					gridLink.text( dates[i].date( ));
					gridLink.attr( 'href', '#' + dates[i].format( 'MM-DD-YYYY' ));
					gridLink.attr( 'title', dates[i].format( 'dddd, MMMM Do, YYYY' ));

					gridItem.addClass( dates[i].format( 'ddd' ).toLowerCase( ));

					if( dates[i].month( ) != firstDate.month( ))
						gridItem.addClass( 'other' )

					if( dates[i].year( ) == currentYear && dates[i].month( ) == currentMonth && dates[i].date( ) == currentDay )
						gridItem.addClass( 'current' );

					if( !local.date.empty && dates[i].month( ) + 1 == local.date.month && dates[i].date( ) == local.date.day && dates[i].year( ) == local.date.year )
						gridItem.addClass( 'selected' );

					gridLink.appendTo( gridItem );
					gridItem.appendTo( newGrid  );
				}

				newGrid.appendTo( local.calendar.grid );

				return;
			};

			var drawCalendar = function( )
			{
				
				normalizeDate( );

				drawHeader( );

				drawGrid( );

				writeDate( );

				return;
			};

			var clickTrap = function( evt )
			{
				evt.preventDefault( );
			};

			var nextMonth = function( )
			{
				local.date.month += 1;

				if( local.date.month > 12 )
				{
					local.date.month = 1;
					local.date.year += 1;
				}
				
				return drawCalendar( );
			};

			var prevMonth = function( )
			{
				local.date.month -= 1;

				if( local.date.month < 1 )
				{
					local.date.month = 12;
					local.date.year -= 1;
				}
				
				return drawCalendar( );
			};

			var nextYear = function( )
			{
				local.date.year += 1

				return drawCalendar( );
			};

			var prevYear = function( )
			{
				local.date.year -= 1

				return drawCalendar( );
			};

			var focusEvent = function( )
			{				
				$( 'body' ).trigger( 'click' );

				drawCalendar( );

				local.calendar.all.addClass( 'active' );
				return;
			};

			var blurEvent = function( evt )
			{
				if( local.settings.myWUSATADate ) {
					$( 'body' ).find( 'div.searchFilters:not(.open)' ).each( function( ) {
						var active = $( this ).hasClass( 'active' );

						if( active ) {
							$( this ).css( 'height', 'auto' ).attr( 'data-height', $( this ).height( )).css( 'height', $( this ).height( ));
						} else {
							$( this ).addClass( 'active' ).attr( 'data-height', $( this ).height( )).removeClass( 'active' );
						}
					});
				}

				if( evt && ( $( '*', local.wrapper ).filter( evt.target ).length || local.wrapper.get( 0 ) == evt.target ))
					return;

				local.calendar.all.removeClass( 'active' );

				if( typeof Placeholders !== 'undefined' )
				{
					Placeholders.disable( local.input.get( 0 ));
					Placeholders.enable(  local.input.get( 0 ));
				}

				if( !local.input.val( ).length )
				{
					local.date.year  = moment( ).year(  );
					local.date.month = moment( ).month( ) + 1;
					local.date.day   = moment( ).date(  );
					local.date.empty = true;
				}

				return;
			};

			var enterDate = function( date )
			{
				date = moment( date );

				if( date.isValid( ))
				{
					local.date.month = date.month( ) + 1;
					local.date.day   = date.date(  );
					local.date.year  = date.year(  );
					local.date.empty = false;
				}

				drawHeader( );

				drawGrid( );

				return;
			}

			var clickDate = function( )
			{
				
				var date = $( this ).attr( 'href' ).replace( '#', '' ).split( '-' );
				
				local.date.month = date[0];
				local.date.day   = date[1];
				local.date.year  = date[2];
				local.date.empty = false;

				$( 'li', local.calendar.grid ).removeClass( 'selected' );

				$( this ).parent( ).addClass( 'selected' );

				writeDate( );
				blurEvent( );

				return;
			}

			var writeDate = function( )
			{
				if( !local.date.empty && local.settings.initialLoad == 0 )
					local.input.maskerade( 'val', local.date.month + '-' + local.date.day + '-' + local.date.year );

				$( 'body' ).trigger( 'dateChanged' );
			}

			var reset = function( )
			{
				
				if( local.input.val( ).length )
				{
					enterDate( resetValue );
					writeDate( );
				}

				blurEvent( );
			}

			var resetDate = function( )
			{
				local.input.val('');
			}

			// Establish root container
			var local = {};

			// Establish local settings
			local.settings = settings;

			local.settings.initialLoad = 1;
			
			if( navigator.userAgent.match(/(iPad|iPhone|iPod|Android)/g) && !local.settings.overrideMobile )
			{
				if( $( this ).val( ).length )
					$( this ).val( moment( $( this ).val( ), local.settings.format ).format( 'YYYY-MM-DD' ));

				$( this ).attr( 'type', 'date' );
				
				//Added for mobile placeholder issue
				$( this ).on(  'focus', $( this ).attr( 'type', 'date' ) );
				$( this ).on(  'blur', $( this ).attr( 'type', 'text' ) );

				return;
			}

			// Normalize date settings
			if( 'now' == local.settings.minYear ) local.settings.minYear = moment( ).year( );
			if( 'now' == local.settings.maxYear ) local.settings.maxYear = moment( ).year( );

			local.settings.minYear = parseInt( local.settings.minYear, 10 );
			local.settings.maxYear = parseInt( local.settings.maxYear, 10 );

			if( local.settings.minYear < 999 && local.settings.maxYear < 999 )
			{
				local.settings.minYear = moment( ).year( ) + local.settings.minYear;
				local.settings.maxYear = moment( ).year( ) + local.settings.maxYear;
			}

			if( local.settings.minYear < 999 ) local.settings.minYear = local.settings.maxYear + local.settings.minYear;
			if( local.settings.maxYear < 999 ) local.settings.maxYear = local.settings.minYear + local.settings.minYear;

			if( local.settings.minYear > local.settings.maxYear )
			{
				var temp = local.settings.minYear;
				local.settings.minYear = local.settings.maxYear;
				local.settings.maxYear = temp;
			}

			// Retrieve and create DOM elements
			local.date           = {};
			local.date.year      = moment( ).year(  );
			local.date.month     = moment( ).month( ) + 1;
			local.date.day       = moment( ).date(  );
			local.date.empty     = false;
			local.calendar       = {};
			local.container      = $( this ).parent( );
			local.placeholder    = $( '<span   />' );
			local.wrapper        = $( '<div    />' );
			local.input          = $( this );
			local.calendar.all   = $( '<div    />' );
			local.calendar.month = $( '<div    />' );
			local.calendar.year  = $( '<div    />' );
			local.calendar.mDec  = $( '<a      />' );
			local.calendar.mInc  = $( '<a      />' );
			local.calendar.yDec  = $( '<a      />' );
			local.calendar.yInc  = $( '<a      />' );
			local.calendar.days  = $( '<ol     />' );
			local.calendar.grid  = $( '<div    />' );
						
			// Insert temporary placeholder
			local.placeholder.insertBefore( local.input );
			local.input.detach( );

			// Set attributes
			local.calendar.mDec.attr( 'href', '#dec' ); local.calendar.mDec.attr( 'title', 'Previous Month' ); local.calendar.mDec.text( '\u25B2' );
			local.calendar.mInc.attr( 'href', '#inc' ); local.calendar.mInc.attr( 'title',     'Next Month' ); local.calendar.mInc.text( '\u25BC' );
			local.calendar.yDec.attr( 'href', '#dec' ); local.calendar.yDec.attr( 'title',  'Previous Year' ); local.calendar.yDec.text( '\u25B2' );
			local.calendar.yInc.attr( 'href', '#inc' ); local.calendar.yInc.attr( 'title',      'Next Year' ); local.calendar.yInc.text( '\u25BC' );

			local.input.removeAttr( 'style' );

			if( undefined != local.input.val( ) && '' != local.input.val( ) && local.input.val( ) != local.input.attr( 'placeholder' ))
			{
				var date = moment( local.input.val( ), local.settings.format );
				local.date.year  = date.year(  );
				local.date.month = date.month( ) + 1;
				local.date.day   = date.date(  );
			}
			else
				local.date.empty = true;

			// Set classes
			local.wrapper.addClass(   'datepicker ' + local.input.attr( 'class' ));
			local.calendar.month.addClass( 'month' );
			local.calendar.year.addClass(   'year' );
			local.calendar.days.addClass(   'days' );
			local.calendar.grid.addClass(   'grid' );
			local.input.removeAttr( 'class' );

			if( local.wrapper.hasClass( 'outerLabel' )) local.input.addClass( 'outerLabel' );

			// Bind events
			local.calendar.mDec.on( 'click', clickTrap ).on( 'click', prevMonth );
			local.calendar.mInc.on( 'click', clickTrap ).on( 'click', nextMonth );
			local.calendar.yDec.on( 'click', clickTrap ).on( 'click', prevYear  );
			local.calendar.yInc.on( 'click', clickTrap ).on( 'click', nextYear  );

			$( local.calendar.grid ).on( 'click', 'a', clickTrap ).on( 'click', 'a', clickDate );

			local.input.on(  'focus', focusEvent );
			//local.input.on( 'change', function( ){ writeDate(); }  );
			local.input.on(  'reset', reset      );
			local.input.on(  'resetDate', resetDate );
			$( 'body' ).on(  'click', blurEvent  );

			// Append elements
			$( '<li class = "sun">S</li>' ).appendTo( local.calendar.days );
			$( '<li class = "mon">M</li>' ).appendTo( local.calendar.days );
			$( '<li class = "tue">T</li>' ).appendTo( local.calendar.days );
			$( '<li class = "wed">W</li>' ).appendTo( local.calendar.days );
			$( '<li class = "thu">T</li>' ).appendTo( local.calendar.days );
			$( '<li class = "fri">F</li>' ).appendTo( local.calendar.days );
			$( '<li class = "sat">S</li>' ).appendTo( local.calendar.days );

			local.calendar.mDec.appendTo(  local.calendar.month );
			local.calendar.mInc.appendTo(  local.calendar.month );
			local.calendar.yDec.appendTo(  local.calendar.year  );
			local.calendar.yInc.appendTo(  local.calendar.year  );
			local.calendar.month.appendTo( local.calendar.all   );
			local.calendar.year.appendTo(  local.calendar.all   );
			local.calendar.days.appendTo(  local.calendar.all   );
			local.calendar.grid.appendTo(  local.calendar.all   );
			local.input.appendTo(          local.wrapper        );
			local.calendar.all.appendTo(   local.wrapper        );

			local.wrapper.insertAfter( local.placeholder );
			
			local.input.maskerade({ mask : 'mm-dd-yyyy', change : enterDate });

			local.placeholder.remove( );

			drawCalendar( );
			
			local.settings.initialLoad = 0;
		});
		
	};
})( jQuery );